import styled, { css } from 'styled-components';

export const BannerContent = styled.div`
  ${({ theme }) => css`
    padding: ${theme.spacing.km6};
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: ${theme.spacing.km6};
    align-items: center;
  `}
`;

export const BannerWrapper = styled.div`
  ${({ theme }) => css`
    border-radius: ${theme.border.radius.default};
    overflow: hidden;
    width: 100%;
    background: ${theme.color.background.neutral.strong};

    container-type: inline-size;

    @container (max-width: 614px) {
      ${BannerContent} {
        flex-direction: column;
        align-items: flex-start;
        gap: ${theme.spacing.km4};

        > div {
          flex-direction: column;
          align-items: flex-start;
        }
      }
    }
  `}
`;
